import * as React from 'react';
import { useDeliveryInstructionsContext } from '../../hooks/useDeliveryInstructionsState';

interface StepHeaderProps {
  children: React.ReactNode;
}

const StepHeader: React.FunctionComponent<StepHeaderProps> = ({ children }) => {
  const {
    state: { stepNavigationChange },
  } = useDeliveryInstructionsContext();
  const stepHeaderRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    if (stepNavigationChange) {
      stepHeaderRef?.current?.focus();
    }
  }, []);

  return (
    <span tabIndex={-1} ref={stepHeaderRef}>
      {children}
    </span>
  );
};

export default StepHeader;
